module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUtJREFUeNqE0s8rRFEUwPF7X34NYab8yPhRMyw0jcXssRJlgZKdBQsWys6Cnb9hFko0/geNHTVNU6RsbBRqatKMDTWShOn5Hs7ohcetT7d77j3vvnPeM0aH67odWMIxHvGEBxxgGi3GM6wmdTOtYUbjeZTRhTBesYVda225elM7kihhBwl0og1hjCODIlbRUE1cQAEp9Jhvg5iDOE5xgSFY2ThHXgLGZ8hBzOEGm1KvQ3wAlyj5JVKXy3SGF4wh6OjeLSrm7/GmZ4Kok0R5WlQW/yRKU2pRxLMkniCiyX41BpgmdJnGvQQncY1DxFDzS2NGcYUc+iQuN2axjZh8YMyy2Y+IPIj1CKTjgY+bPkv7+nNCTItY0Vor2gypqYB1DGMZ+0hazys1Mg1iSg+1aiOOsId6bGBeP82PRjSjV19Vfrkmz14Uady9CzAAuL3/eXq+osMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/搜索.png
// module id = EAMo
// module chunks = 1